export default "__VITE_ASSET__BOCI6jNA__"